const isDev = import.meta.env.DEV;
const isTest = import.meta.env.MODE === 'test';

// ============================================================
// 手动配置区域 (用于本地开发时强制切换后端环境)
// 取消注释下方对应的行即可生效。注意：提交代码时请务必注释回去！
// ============================================================

// 1. 强制连接生产环境
// const MANUAL_ENV = 'production';

// 2. 强制连接测试环境
// const MANUAL_ENV = 'test';

// 3. 强制连接本地后端 (默认)
// const MANUAL_ENV = 'local';

// ============================================================

let apiUrl = import.meta.env.VITE_API_URL;
let staticUrl = import.meta.env.VITE_STATIC_URL;

if (typeof MANUAL_ENV !== 'undefined') {
  console.warn(`⚠️ 当前正使用手动配置的后端环境: ${MANUAL_ENV}`);
  switch (MANUAL_ENV) {
    case 'production':
      apiUrl = 'https://api.diva-ai.cn/api';
      staticUrl = 'https://api.diva-ai.cn';
      break;
    case 'test':
      apiUrl = 'https://api-competition-test.diva-ai.cn/api';
      staticUrl = 'https://api-competition-test.diva-ai.cn';
      break;
    case 'local':
    default:
      apiUrl = 'http://localhost:3000/api';
      staticUrl = 'http://localhost:3000';
      break;
  }
}

// 使用环境变量，如果未定义则回退到默认逻辑
export const API_URL = apiUrl || (isDev ? 'http://localhost:3000/api' : 'https://api.diva-ai.cn/api');

export const STATIC_URL = staticUrl || (isDev ? 'http://localhost:3000' : 'https://api.diva-ai.cn');
